<template>
  <div>
    <md-card-media class="CoverBanner">
      <img
        :src="profile.bannerImg || defaultBannerImg"
        alt="Background"
        class="imgCover"
      />
    </md-card-media>

    <md-card-content class="profileInfo">
      <div class="divImgAvatar">
        <md-avatar class="md-large avatarProfile">
          <img :src="profile.profileImg || defaultProfileImg" alt="Avatar" class="imgAvatarProfile" />
        </md-avatar>
      </div>
      <div class="divName">
        <div class="md-title nameProfile">{{ profile.fullName || profile.name }}</div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
export default {
  name: "sidebarProfile",
  computed: {
    profile() {
      return (
        this.$route.params.user || {
          email: "seu@email.com",
          fullName: "Nome Sobrenome",
          name: "Nome"
        }
      );
    }
  },
  data: () => ({
    defaultBannerImg: require('@/assets/coverDefault.png'),
    defaultProfileImg: require('@/assets/avatarDefault.png')
  })
};
</script>

<style scoped>
/* .CoverBanner{
  top: 0;
  height: 35vh;
  border-bottom: solid 1px;
  background-color: cadetblue;
} */

.imgCover {
  top: 0;
  height: 35vh;
  border-bottom: solid 1px;
  object-fit: cover;
}

.profileInfo {
  position: relative;
  text-align: center;
  transform: translateY(-90px)
}

.divImgAvatar {
  position: relative;
  display: block;
  background-color: #fff;
  padding: 3px;
  width: fit-content;
  border-radius: 100%;
  margin: auto;
}

/* .md-avatar.avatarProfile {
  width: 160px;
  height: 160px;
} */

/* .md-avatar{
  position: relative;
  top: 0;
  margin: 0
} */

.divName {
   padding: 10px;
}

/* .nameProfile{
  color: #fff;
} */

/* .descriptionProfile {
  padding-bottom: 0px;
} */

</style>
